<template>
	<div class="filling-options">
		<div class="filling-top text__a">
			<div class="header5">Filing</div>
			<div class="header3">Appeal</div>
			<div class="filling-options-text paragraph">
				<h2>You have two ways to save:</h2>
				<h3>File An Appeal Yourself</h3>
				<p>
					Do the research and provide all the documents and analysis necessary for your appeal, along with the completed appeal forms
					required by the County to file on your own.
				</p>
				<h3>Garbur Appeals For You</h3>
				<p>
					Garbur manages the appeal process for you from start to finish. Garbur will do all the research, generate all necessary appeal
					documents, file the appeal with the County on your behalf and notify you when we have a result.
				</p>
				<!--<p>
					Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cum, dolorem! Veritatis eius ad laboriosam libero, quasi dolor commodi
					et facere possimus consequuntur fugit est animi.
				</p>
				<p>
					Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cum, dolorem! Veritatis eius ad laboriosam libero, quasi dolor commodi
					et facere possimus consequuntur fugit est animi. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Facere atque reiciendis
					ad, culpa doloribus magnam et ea accusantium aliquam facilis sit ducimus maxime provident illo nulla libero alias blanditiis iste
					illum, ipsa at voluptatem sapiente pariatur. Perferendis esse nulla iusto doloribus ad tempora fugiat minus eligendi, aliquam,
					quibusdam, itaque ipsum.
				</p>-->
			</div>
		</div>
		<!--
		<FillingOption
			class="op1"
			planName="Option One"
			planTitle="File on your own"
			:planPrice="fees.selfServiceFee"
			:changePlan="changePlan"
			:activePlan="activePlan"
		/>
		-->
		<FillingOption
			class="op2"
			planName="Let us help you"
			planTitle="File your Appeal"
			planPrice="0"
			:planDetails="fees"
			:changePlan="changePlan"
			:activePlan="activePlan"
			:isRecommended="true"
		/>
		<div class="filling-btn-cont">
			<Button title="Next" :onClick="goConfirm" />
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import FillingOption from "@/components/account/FillingOption.vue";
import Button from "@/components/ui/Button.vue";
// import { NEW_ORDER } from "./../store/constants";
import localData from "@/store/utils/localdata";
import api from "@/store/utils/api";

export default {
	name: "filling-options",
	title: "Filling Options",
	components: {
		FillingOption,
		Button,
	},
	data() {
		return {
			picked: "",
			activePlan: "",
			activePlanValue: 0,
			casePayment: 0,
			fees: {},
		};
	},
	async mounted() {
		window.scrollTo(0, 0);
		this.changePlan(this.planName.letGarburHandleIt);

		const fees = await api.get("/api/v1/options/fees");
		this.fees = fees;

		if (localData.getItem("activePlanValue")) {
			this.activePlanValue = localData.getItem("activePlanValue");
			// Mount default depends on saving
			if (this.property.savingAmount >= 1500) {
				this.activePlanValue = 2;
			} else if (this.property.savingAmount < 1500) {
				this.activePlanValue = 1;
			}

			this.casePayment = localData.getItem("casePayment");

			if (this.activePlanValue == 1) {
				this.activePlan = "Option One";
				this.casePayment = fees.selfServiceFee;
			} else if (this.activePlanValue == 2) {
				this.activePlan = "Option Two";
				this.casePayment = 0;
			}
		}
	},
	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
	},
	methods: {
		goConfirm() {
			if (this.$store.state.auth.userId) this.goToConfirm(this.$store.state.auth.userId);
			else this.goToConfirm();
		},
		async goToConfirm(userId) {
			try {
				this.$router.push(`/confirm?pid=${this.$route.params.id}&purchaseDate=&purchaseAmount=&filingOption=${this.activePlanValue}`);
			} catch (ex) {}
		},
		changePlan(plan) {
			this.activePlan = plan;
			if (this.activePlan == "Option One") {
				this.activePlanValue = 1;
				this.casePayment = 50;
			} else if (this.activePlan == "Option Two") {
				this.activePlanValue = 2;
				this.casePayment = 0;
			}
			localData.setItem("filingOption", this.activePlanValue);
			localData.setItem("activePlanValue", this.activePlanValue);
			localData.setItem("casePayment", this.casePayment);
		},
	},
};
</script>

<style scoped lang="scss">
.filling-options {
	padding: 4rem 3.7rem;
	max-width: 1355px;
	text-align: left;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(345px, 1fr));
	grid-gap: 25px;
	grid-template-areas: "text__a op1 op2" ". . btn";
	margin: 0 auto;
	.filling-top {
		.filling-options-text.paragraph {
			color: var(--black);
			opacity: 0.5;
			margin-top: 20px;
		}
	}
	.header5 {
		color: var(--accent);
		padding-bottom: 10px;
	}
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--dark-gray);
	}
	.op1 {
		grid-area: op1;
	}
	.op2 {
		grid-area: op2;
	}
	.text__a {
		grid-area: text__a;
	}
	.filling-btn-cont {
		display: grid;
		grid-area: btn;
		padding: 20px 0;
		align-items: center;
		justify-items: end;
	}
}

.filling-options > div {
	margin-bottom: 30px;
}
@media (max-width: 1235px) {
	.filling-options {
		display: grid;
		grid-template-areas:
			"text__a text__a"
			"op1 op2 "
			". btn";
	}
}
@media (max-width: 845px) {
	.filling-options {
		display: grid;
		grid-template-areas:
			"text__a"
			"op1"
			"op2"
			"btn";
	}
}
@media (max-width: 450px) {
	.filling-options {
		padding: 3rem 1rem;
		.filling-top {
			width: unset;
		}
		.filling-top .filling-options-text.paragraph {
			display: none;
		}
	}
}
</style>
